import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { SECTION_NAME_MAX_LENGTH } from 'src/features/templateEdit/validates/questionValidations'

type Props = {
  title: string
  label: string
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
}

/** 選択中の見出し(列見出しまたはセル)の設定パネル。 */
export const TableRowHeadingSettings = ({
  title,
  label,
  value,
  onChange,
  onBlur,
}: Props) => (
  <Stack spacing={2} sx={{ width: '100%', p: 3 }}>
    <Typography sx={{ fontSize: 18, fontWeight: 700, lineHeight: '28px' }}>
      {title}
    </Typography>
    <Stack spacing={0.75}>
      <Typography
        component="label"
        htmlFor="table-row-heading-name"
        variant="body2"
        fontWeight={700}
      >
        {label}
      </Typography>
      <TextField
        id="table-row-heading-name"
        size="small"
        fullWidth
        value={value}
        // 見出しは section.name に保存するので、保存時の検証と同じ上限で打てなくする
        slotProps={{ htmlInput: { maxLength: SECTION_NAME_MAX_LENGTH } }}
        onChange={event => onChange(event.target.value)}
        onBlur={onBlur}
      />
    </Stack>
  </Stack>
)
